<body id="scrollarea-invalid" class="warehouse-outbound">
  <div class="warehouse-outbound-container">
    <h3 class="page-title">{{ CONST.WAREHOUSE_OUTBOUND }}</h3>
    <ion-row>
      <ion-col size="10" class="custom-col">
        <app-add-new-scan
          [form]="form"
          [hasFileUploadButton]="true"
          [fileType]="PARSE_TYPE.TRACKINGNUMBER_ONLY"
          (emitSubmit)="submit($event, false)"
          (emitFileUpload)="submit($event, true)"
        ></app-add-new-scan>
      </ion-col>
    </ion-row>
    <!-- Table -->
    @if (dataSource.data.length > 0 && !isFileUpload) {
      <div class="warehouse-outbound-table-container">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          id="excel-table"
          class="warehouse-outbound-table"
        >
          <!-- TRACKING_NUMBER -->
          <ng-container matColumnDef="item">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="trackingNumber-headers"
              class="tracking-number-column-header"
            >
              <app-table-search-component
                [columnName]="COLUMNTEXT.TRACKING_NUMBER"
                [control]="trackingNumberData.formControl"
                [maxLength]="18"
                [textInputWidth]="209"
                [searchIconOffset]="62"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
              headers="trackingNumber-headers"
              class="tracking-number-data-column"
            >
              <app-table-tracking-number-cell
                [trackingNumber]="warehouseScan.item"
              ></app-table-tracking-number-cell>
            </td>
          </ng-container>

          <!-- SORT_DATE -->
          <ng-container matColumnDef="sortDate">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortDate-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.SORT_DATE }}</ion-row>
              <div class="sort-date-picker-container date-picker-container">
                <app-form-date-picker
                  [icon]="SRC.CALENDAR"
                  [placeholder]="CONST.SELECT_DATE"
                  [formControl]="sortDate.formControl"
                  (valueChange)="search()"
                ></app-form-date-picker>
              </div>
            </th>

            <td
              headers="sortDate-headers"
              class="selectable cursor-pointer sortDate-data-column"
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
            >
              {{ warehouseScan.sortDate }}
            </td>
          </ng-container>

          <!-- SORT_CODE -->
          <ng-container matColumnDef="sortCode">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortCode-headers"
              class="sortCode-header-container"
            >
              <app-table-header-dropdown
                [columnText]="COLUMNTEXT.SORT_CODE"
                [itemId]="sortCode.itemId"
                [searchResults]="sortCodeOption"
                [resetData]="resetSelectDropdowns"
                [showDropdown]="dropdownOpen[0]"
                (dropdownChange)="
                  dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
                "
                (checkboxesUpdated)="
                  onStatusChangeForDropdowns($event, sortCode)
                "
                [popoverStyle]="{ maxWidth: 100, offsetX: -65 }"
              >
              </app-table-header-dropdown>
            </th>

            <td
              headers="sortCode-headers"
              class="selectable cursor-pointer sortCode-data-column"
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
            >
              {{ warehouseScan.sortCode }}
            </td>
          </ng-container>

          <!-- REASON -->
          <ng-container matColumnDef="reason">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="reason-headers"
              class="reason-column-header"
            >
              <div class="th-text">
                {{ COLUMNTEXT.REASON }}
              </div>
              <div class="empty-item"></div>
            </th>

            <td
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
              headers="reason-headers"
              class="reason-data-column"
            >
              <p>
                {{ warehouseScan.reason }}
              </p>
            </td>
          </ng-container>

          <!-- FLEX -->
          <ng-container matColumnDef="flex">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="flex-headers"
              class="flex-column-header"
            >
              <div class="th-text">
                {{ COLUMNTEXT.FLEX }}
              </div>
              <div class="empty-item"></div>
            </th>

            <td
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
              headers="flex-headers"
              class="flex-data-column"
            >
              <p>
                {{ warehouseScan.flex }}
              </p>
            </td>
          </ng-container>

          <!-- STATUS -->
          <ng-container matColumnDef="status">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="status-headers"
              class="status-column-header"
            >
              <div class="th-text">
                {{ COLUMNTEXT.STATUS }}
              </div>
              <div class="empty-item"></div>
            </th>

            <td
              mat-cell
              *matCellDef="let warehouseScan; let i = index"
              headers="status-headers"
              class="status-data-column"
            >
              <p>
                {{ warehouseScan.code }}
              </p>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-border no-results"
              [attr.colspan]="displayedColumns.length"
            >
              <app-no-results-found></app-no-results-found>
            </td>
          </tr>
        </table>
      </div>
    }

    @if (
      isFileUpload &&
      (commonUtils.fileUploadResponse().accepted > 0 ||
        commonUtils.fileUploadResponse().rejected.length > 0 ||
        commonUtils.fileUploadResponse().itemsNonProcessed.length > 0)
    ) {
      <app-file-upload-results
        [response]="commonUtils.fileUploadResponse()"
      ></app-file-upload-results>
    }
  </div>
</body>
